<script>
  import { makeWebsiteRequest } from "../../Common/tools";
  import { onMount } from "svelte";
  import Table from "../../Table/Table.svelte";
  import {External, M} from "../../external";

  export let data, filters;
  let activeColumns = null;

  let initialLoad = true;
  let loading = true;
  let currentPage = 0;
  let pagesCount = 0;
  let table = null;

  let tableData = {
    columns: [
      { key: "col0", label: M.NAME, class: "flex-1 mw-240" },
      { key: "col1", label: M.EMAIL, class: "flex-none" },
      {
        key: "open",
        label: M.OPEN_RATE,
        type: "percent",
        rowClass: "pay-status paid",
        class: "flex-none mw-140"
      },
      {
        key: "click",
        label: M.CLICK_RATE,
        type: "percent",
        rowClass: "order-status pending",
        class: "flex-none mw-140"
      }
      //{key: 'sales', label: 'Sales', class: 'flex-none mw-140'}
    ],
    rows: []
  };

  export function onReloadData() {
    load(0);
  }

  let load = async (page) => {
    if (loading && !initialLoad) {
      return;
    }
    initialLoad = false;

    if (page === 0) {
      data.rows = [];
    } else if (page > 0 && currentPage + 1 >= pagesCount) {
      return;
    }
    loading = true;

    let request = {
      page: page
    };

    let response = await makeWebsiteRequest({
      action: "getUnsubscribedContacts",
      data: request
    });

    if (!response.data) {
      loading = false;
      return;
    }

    data.count = response.data.count;
    pagesCount = response.data.pagesCount;
    currentPage = page;

    if (activeColumns != null) {
      let count = 0;
      let columns = [];
      activeColumns.forEach(function (column) {
        let prop = External.getById(External.Website.crmProperties, column);
        columns.push({
          key: "col" + count++,
          label: prop.label,
          class: prop.id === -1 ? "flex-1 mw-240" : "flex-none"
        });
      });
      columns.push({
        key: "open",
        label: M.OPEN_RATE,
        type: "percent",
        rowClass: "pay-status paid",
        class: "flex-none mw-140"
      });
      columns.push({
        key: "click",
        label: M.CLICK_RATE,
        type: "percent",
        rowClass: "order-status pending",
        class: "flex-none mw-140"
      });
      columns.push({ key: "sales", label: "Sales", class: "flex-none mw-140" });

      tableData.columns = columns;
    }

    if (table) table.addRows(response.data.items);
    loading = false;
  };

  let onClick = (row) => {
    External.CPanel.goToUrl("/me/crm/contact/" + row.id + "?tab=marketing", true);
  };

  let onNext = () => {
    load(currentPage + 1);
  };

  onMount(function () {
    // ignore, data is loaded from onReloadData
  });
</script>

<Table activeColumns={tableData.columns} bind:this={table} data={tableData.rows} loading={loading} hasSelection={false} onClick={onClick} nextPage={onNext}>
  <div class="text-center col20 f-left" style="padding: 70px 30px; box-sizing: border-box;">
    <h4 class="col20 f-left t-center mb-15">{M.NO_UNBUSCRIBED_USERS}</h4>
  </div>
</Table>
